import {
  CountryFlag,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@aircall/ds";
import type { ReactNode } from "react";

import { SCORE_CARD_LANGUAGES } from "./ScorecardLanguageSelect.constants";
import {
  LanguageOption,
  ScorecardLanguageSelectProps,
} from "./ScorecardLanguageSelect.decl";

function renderOption({ name, countryCode }: LanguageOption) {
  return (
    <div className="flex items-center gap-1">
      <CountryFlag countryIsoCode={countryCode} size="sm" />
      <span className="text-xs">{name}</span>
    </div>
  );
}

export function ScorecardLanguageSelect({
  onChange,
  value,
  "data-test": dataTest = "scorecard-language-select",
}: ScorecardLanguageSelectProps) {
  const items: { label: ReactNode; value: string }[] = SCORE_CARD_LANGUAGES.map(
    (option) => ({
      label: renderOption(option),
      value: option.languageCode,
    })
  );

  return (
    <Select<string>
      items={items}
      value={value}
      onValueChange={(nextValue) => {
        if (nextValue !== null) {
          onChange(nextValue);
        }
      }}
    >
      <SelectTrigger data-test={`${dataTest}-trigger`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {SCORE_CARD_LANGUAGES.map((option) => (
          <SelectItem
            key={option.languageCode}
            value={option.languageCode}
            data-test={`${dataTest}-option-${option.languageCode}`}
          >
            {renderOption(option)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
